import { render } from "./HeroSection.vue?vue&type=template&id=57d84e81&scoped=true"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=57d84e81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d84e81"]])

export default __exports__